import { useEffect, useState } from "react";
import logo from "../../_assets/images/logo.png";
import logo_b from "../../_assets/images/logo_b.png";
import ASMRMainComponent from './ASMRMainComponent';
import { ContentComponent } from "../ComponentCss";
import { useLocation } from "react-router-dom";



const ASMRComponent = ({ asmrMainRef, warEleRef, marrEleRef }) => {
    const [spyEle, setSpyEle] = useState('');
    const [bgIsBlack, setBgIsBlack] = useState(true);
    const [supportVisible, setSupportVisible] = useState(true);

    return (    
      <ContentComponent bgIsBlack={ bgIsBlack } spyEle={ spyEle } supportVisible={ supportVisible }  ref={ asmrMainRef }>
        <article id="main">
          <ASMRMainComponent spyEle={ spyEle } setSpyEle={ setSpyEle } setBgIsBlack={setBgIsBlack} setSupportVisible={setSupportVisible} warEleRef={ warEleRef } marrEleRef={ marrEleRef } />
        </article>
        <button className="support-cont pc" onClick={ () => window.open("https://www.unicef.or.kr/donate/?supportTerm=FM01&supportCategory=D001&solicitcode=DR22E") } alt="후원하기 버튼">
          <img src={ "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/support_btn.5f0c666ffee388070630.png" } alt="후원하기 버튼 이미지" style={{ width: "15rem" }} />
        </button>
        <button className="support-cont2 mo" onClick={ () => window.open("https://www.unicef.or.kr/donate/?supportTerm=FM01&supportCategory=D001&solicitcode=DR22E") } alt="후원하기 버튼">
          <img src={ "https://cdn.unicef.or.kr/images/22unicef-asmr/static//media/support_btn2.e3baf47c8ce00f5976aa.png" } alt="후원하기 버튼 이미지" />  
        </button>
        <img src={ spyEle === "" ? logo : logo_b } alt="유니세프 로고" className="logo pc" />        
    </ContentComponent>
    );
}

export default ASMRComponent;